module.exports = __webpack_public_path__ + "static/media/no-photo.10dbda07.png";